import { Typography } from '@material-ui/core';
import {
  AuditionRequestIcon,
  ClockCircleIcon,
  LoadingSpinnerIconTwoTone,
  NotificationsAlertWhiteIcon,
  SelfTapesIcon,
} from '@room-match/shared-ui-components';
import { Avatar } from 'components/Avatar';
import { useHistory, useParams } from 'react-router-dom';
import { COLORS } from 'shared/constants/COLORS';
import { ROUTES } from 'shared/constants/ROUTES';
import { IAuditionSchedulesAttributes } from 'shared/interfaces/IAuditionSchedule';
import { readableProjectUnion } from 'shared/utils/room-shared';
import { STTimeDateParser, auditionTimeParse, timeConvert, timeParser } from 'shared/utils/timeHelpers';

import React, { Fragment, useState } from 'react';
import { AuditionPhase } from 'shared/enums/AuditionPhase';
import { AuditionStatus } from 'shared/enums/AuditionStatus';
import {
  Content,
  FlexRightContainer,
  Header,
  HeaderMiddleContainer,
  IconCont,
  MainContainer,
} from './AuditionItem.styles';

type Props = {
  data: IAuditionSchedulesAttributes;
  country?: string;
  request?: boolean;
  pastST?: boolean;
  isHistory?: boolean;
};

const AuditionItem: React.FC<Props> = ({ data, request: req, pastST, isHistory, country = 'au' }) => {
  const history = useHistory();
  const [imgLoaded, setimgLoaded] = useState(false);
  const { tab } = useParams() as { tab: string };

  const agency = data.audition;

  const { status, self_tapes_requirement_revision, cd_rescheduled } = data;
  const isReschedule = cd_rescheduled;
  const isCancelled = status === AuditionStatus.CANCELLED;
  const isRevision = self_tapes_requirement_revision;

  return (
    <MainContainer
      onClick={() =>
        history.push(
          pastST ? `${ROUTES.TALENT.PAST_SELFTAPES}/${data.id}` : `${ROUTES.TALENT.AUDITIONS}/${tab}/${data.id}`,
        )
      }
      style={{
        borderColor: isRevision
          ? COLORS.REVISION_BORDER
          : isReschedule
            ? COLORS.WARNING
            : isCancelled
              ? COLORS.DANGER
              : COLORS.DARK_BORDER,
      }}
    >
      <Header>
        {!req ? (
          agency.casting_role.project.logo ? (
            <div style={{ position: 'relative' }}>
              {!imgLoaded && <LoadingSpinnerIconTwoTone style={{ width: 40, height: 40, position: 'absolute' }} />}
              {agency.casting_role.project.logo ? (
                <img
                  src={`${agency.casting_role.project.logo}/40x40`}
                  style={{ width: 40, height: 40, borderRadius: 5 }}
                  onLoad={() => setimgLoaded(true)}
                />
              ) : (
                <div>wala</div>
              )}
            </div>
          ) : (
            <Avatar
              style={{ height: 44, width: 44, borderRadius: 5 }}
              title={data.audition.casting_role.project.name}
              uuid={data.audition.casting_role.project.id}
            />
          )
        ) : data.status === 'Reschedule' || isReschedule ? (
          <IconCont BG={COLORS.WARNING}>
            <ClockCircleIcon />
          </IconCont>
        ) : (
          <IconCont BG={COLORS.PRIMARY}>
            <NotificationsAlertWhiteIcon />
          </IconCont>
        )}
        <HeaderMiddleContainer>
          <Typography>{data.audition.casting_role.project.name || '–'}</Typography>
          <Typography style={{ fontSize: 14, color: isReschedule ? COLORS.WARNING : undefined }}>
            {isReschedule
              ? 'CD Rescheduled'
              : data.audition.casting_role.project.union
                ? readableProjectUnion(data.audition.casting_role.project.union)
                : '–'}
          </Typography>
        </HeaderMiddleContainer>
        {req ? (
          <FlexRightContainer isSelftapes={data.phase == 'Self Tapes Request'}>
            {data.phase == 'Self Tapes Request' ? <SelfTapesIcon /> : <AuditionRequestIcon />}
            <Typography style={{ fontSize: 14, whiteSpace: 'nowrap' }}>
              {data.phase == 'Self Tapes Request' ? 'Self Tape' : 'Audition'}
            </Typography>
          </FlexRightContainer>
        ) : (
          <Fragment />
        )}
      </Header>
      <Content>
        <div>
          <Typography style={{ fontSize: 14, fontWeight: 400 }}>Rep:</Typography>
          <Typography style={{ fontSize: 14 }} color="primary">
            {data.audition.profile.agency ? (
              <Typography color="primary" style={{ fontSize: 14 }}>
                {data.audition.profile.agency.full_name || data.audition.profile.agency?.name}
              </Typography>
            ) : data.audition.profile.casting_private ? (
              <Typography style={{ fontSize: 14, color: COLORS.ORANGE }}>Private</Typography>
            ) : (
              <Typography style={{ fontSize: 14, color: '#a759ff' }}>
                {country !== 'au' ? 'Non Represented' : 'Freelance'}
              </Typography>
            )}
          </Typography>
        </div>
        <div>
          <Typography style={{ fontSize: 14 }}>Role:</Typography>
          <Typography style={{ fontSize: 14 }}>{data.audition.casting_role.name || ''}</Typography>
        </div>
        {!isCancelled || isRevision ? (
          <div>
            <Typography style={{ fontSize: 14, color: isReschedule ? COLORS.WARNING : undefined }}>
              Date & Time:
            </Typography>
            <Typography style={{ fontSize: 14, ...(isReschedule && { color: COLORS.WARNING }) }}>
              {data.phase === AuditionPhase.SELF_TAPES_PROCESS || data.phase === AuditionPhase.SELF_TAPES_REQUEST
                ? STTimeDateParser(
                    data.audition.casting_role.self_tapes_requirements?.date || '',
                    data.audition.casting_role.self_tapes_requirements?.time || '',
                    data.audition.casting_role.self_tapes_requirements?.timezone || '',
                  )
                : timeConvert(data)}
            </Typography>
          </div>
        ) : (
          <React.Fragment />
        )}
        {isHistory ? (
          <React.Fragment />
        ) : (
          <div>
            <Typography style={{ fontSize: 14, color: isReschedule ? COLORS.WARNING : undefined }}>Due:</Typography>
            <Typography style={{ fontSize: 14, ...(isReschedule && { color: COLORS.WARNING }) }}>
              {data.phase === AuditionPhase.SELF_TAPES_PROCESS || data.phase === AuditionPhase.SELF_TAPES_REQUEST
                ? timeParser(
                    data.audition.casting_role.self_tapes_requirements?.date || '',
                    data.audition.casting_role.self_tapes_requirements?.time || '',
                    data.audition.casting_role.self_tapes_requirements?.timezone || '',
                  )
                : auditionTimeParse(data)}
            </Typography>
          </div>
        )}
        {data.audition.profile.agency && (
          <div>
            <Typography style={{ fontSize: 14 }}>Location:</Typography>
            <Typography style={{ fontSize: 14 }}>
              {data.audition.profile.agency?.state && data.audition.profile.agency?.country
                ? `${data.audition.profile.agency?.state}, ${data.audition.profile.agency?.country}`
                : data.audition.profile.agency?.state
                  ? data.audition.profile.agency?.state
                  : data.audition.profile.agency?.country
                    ? data.audition.profile.agency?.country
                    : '-'}
            </Typography>
          </div>
        )}
      </Content>
      {isCancelled || isRevision ? (
        <div
          style={{
            background: isCancelled ? COLORS.DANGER : COLORS.REVISION_BORDER,
            borderBottomLeftRadius: '8px',
            borderBottomRightRadius: '8px',
            padding: '8px',
          }}
        >
          {isCancelled ? (
            <p style={{ fontSize: 14, textAlign: 'center', color: '#fff' }}>Cancelled by Casting</p>
          ) : null}
          <p style={{ fontSize: 14, textAlign: 'center', color: '#fff' }}>
            {isRevision ? 'ST Revsion' : 'Job Cancelled'}
          </p>
        </div>
      ) : (
        <React.Fragment />
      )}
    </MainContainer>
  );
};

export default AuditionItem;
